import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { Accordion, ActionIcon, Alert, Box, Button } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type UNSAFE_any } from '@flecto/types'
import { Icon, TimePickerInput } from '@flecto/ui'
import { formatDateString } from '@flecto/utils'

import { useBusinessHour } from './BusinessHoursProvider'
import styles from './styles.module.css'

export function AccordionHours() {
  const { t } = useTranslation('saas', { keyPrefix: 'general' })
  const {
    changeHour,
    hours,
    removeFromKey,
    handleAddHour,
    isDuplicateHourByKey,
    isInvalidByKey,
  } = useBusinessHour()
  return (
    <Accordion.Panel className={styles.accordionContent}>
      {hours.map((hour: UNSAFE_any, index: number) => {
        const isInvalid = isInvalidByKey(hour.key)
        const isDuplicate = isDuplicateHourByKey(hour.key)
        const renderInvalid = isInvalid || isDuplicate

        return (
          <Box key={hour.key} className={styles.businessHoursItem}>
            <Box className={styles.businessHoursItemStart}>
              <TimePickerInput
                value={formatDateString({
                  date: hour.start,
                  variant: 'time-brief',
                })}
                onChange={(time) =>
                  time &&
                  changeHour(index, new Date(`2000-01-01T${time}:00`), true)
                }
                style={{ zIndex: 9999 }}
              />
            </Box>
            <Box className={styles.businessHoursItemDash}>-</Box>
            <Box className={styles.businessHoursItemEnd}>
              <TimePickerInput
                value={formatDateString({
                  date: hour.end,
                  variant: 'time-brief',
                })}
                onChange={(time) =>
                  time &&
                  changeHour(index, new Date(`2000-01-01T${time}:00`), false)
                }
                style={{ zIndex: 9999 }}
              />
            </Box>
            <ActionIcon
              w={40}
              miw={40}
              style={{ flexShrink: 0 }}
              variant='default'
              onClick={() => removeFromKey(hour.key)}
              disabled={hours.length === 1}
              className={styles.businessHoursItemDelete}
            >
              <Icon icon={faTrash} />
            </ActionIcon>
            {renderInvalid && (
              <Alert
                py='sm'
                variant='light'
                color='red'
                icon={<Icon icon={faInfoCircle} />}
                className={styles.businessHoursItemAlert}
              >
                {isInvalid &&
                  !isDuplicate &&
                  t('shared.modules.address.invalid_timerange')}
                {isDuplicate &&
                  t('shared.modules.address.duplicated_timerange')}
              </Alert>
            )}
          </Box>
        )
      })}
      <Button
        size='sm'
        variant='default'
        w={150}
        leftSection={<Icon icon={faPlus} />}
        onClick={handleAddHour}
      >
        {t('shared.modules.address.add_schedule')}
      </Button>
    </Accordion.Panel>
  )
}
